'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var validator = new _auroraJavascriptUtils.ValidatorFactory();

/**
 * see java `org.springframework.data.domain.Sort.Order`
 */
var OrderModel = Nested.Model.extend({
    defaults: {
        direction: String.value('asc').has.check(validator.oneOf(['asc', 'desc']), validator.oneOf(['asc', 'desc']).message),

        property: String.value(null).has.check(validator.notNull(), validator.notNull().message),

        ignoreCase: Boolean.value(false),
        nullHandling: String.value(null) // [NATIVE, NULLS_FIRST, NULLS_LAST]
    },

    toggleDirection: function toggleDirection() {
        this.direction = this.direction === 'asc' ? 'desc' : 'asc';
    }
});

/**
 * contains parameters for page navigation
 */
var NavigationModel = Nested.Model.extend({
    defaults: {
        pageSize: Number.value(null), // todo(egor): add validator
        pageNumber: Number.value(null), // todo(egor): add validator
        sort: OrderModel.Collection // todo: is order of elements checks here ?
    },

    togglePrimarySortingDirection: function togglePrimarySortingDirection() {
        this.sort.models[0].toggleDirection();
    },
    setPrimarySortingProperty: function setPrimarySortingProperty(property) {
        _auroraJavascriptUtils.assert.string(property);

        this.sort.models[0].property = property;
    }
});

exports.default = NavigationModel;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/paged/NavigationModel.js
// module id = 1416
// module chunks = 118